import { FormControl, ValidatorFn, Validators } from '@angular/forms';

import { RegexUtils } from 'tiime-expert-utils';

import { FormHelper } from '@helpers/form.helper';
import { ErrorMessage } from '@interfaces/error-message';

export class SiretAlphaNumericFormControl extends FormControl<string | null | undefined> {
  get errorMessage(): string {
    const error: ErrorMessage | null = FormHelper.composeErrorMessages(this, [
      {
        method: 'simpleErrorMessage',
        args: [
          {
            simpleErrorCode: 'pattern',
            simpleErrorMessage: 'Un numéro de SIRET doit avoir 14 caractéres ou chiffres'
          }
        ]
      },
      { method: 'getEmptyErrorMessage', args: ['Le numéro de SIRET est requis'] }
    ]);

    return error?.message ?? null;
  }

  constructor(
    readonly value: string | null | undefined = null,
    readonly additionalValidators: ValidatorFn[] = []
  ) {
    super(value, [...additionalValidators, Validators.pattern(RegexUtils.siretAlphaNumericRegex)]);
  }
}
